import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig } from "./auth";

import { 
    GET_PROJECTS, 
    GET_COMPANY_PROJECTS, 
    GET_PROJECTS_OUTGOING, 
    SET_PROJ_HIDDEN_HIDE, 
    SET_PROJ_VISIBLE, 
    SET_PROJ_HIDDEN, 
    GET_PROJECT_FAVORITES, 
    ADD_PROJECT_FAVORITE, 
    REMOVE_PROJECT_FAVORITE, 
    GET_PROJECT, 
    CLEAR_PROJECT, 
    CLEAR_PROJECTS,
    CREATE_PROJECT, 
    EDIT_PROJECT, 
    DELETE_PROJECT, 
    ARCHIVE_PROJECT, 
    GET_PROJECTS_DROPS,
    SET_PROJECT_DROP,
    TOGGLE_SHOW_HIDDEN_PROJECTS,
    GET_PROJECTS_INCLUDING_HIDDEN,
    SET_PROJECT_VIEWERS
} from "./types";

// GET ALL PROJECTS (RELATED TO USER)
export const getProjects = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/project/get-project-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const projects = res.data;
                const projectDrops = res.data.map((project) => {
                    return {project_id: project.project_id, project_name: project.project_name}
                })
                dispatch({
                    type: GET_PROJECTS,
                    payload: {projects, projectDrops},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET ALL PROJECTS (RELATED TO USER, INCLUDING HIDDEN)
export const getProjectsIncludingHidden = () => (dispatch, getState) => {
    axios
        .put(`/v0/api/project/get-project-list`, {"get_hidden": true}, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const projects = res.data;
                const projectDrops = res.data.map((project) => {
                    return {project_id: project.project_id, project_name: project.project_name}
                })
                dispatch({
                    type: GET_PROJECTS_INCLUDING_HIDDEN,
                    payload: {projects, projectDrops},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET COMPANY PROJECTS (PROJECTS RELATED TO USER'S COMPANY)
export const getCompanyPojects = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/project/get-company_project-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_COMPANY_PROJECTS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET ALL PROJECT FAVORITES
export const getProjectFavorites = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/project/get-project-favorite`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PROJECT_FAVORITES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET ALL OUTGOING PROJECTS
export const getProjectsOutgoing = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/project/get-project-outgoing-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PROJECTS_OUTGOING,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET PROJECT INFORMATION
export const getProject = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/project/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const project = res.data;
                const projectDrop = {project_id: res.data.project_id, project_name: res.data.project_name}
                dispatch({
                    type: GET_PROJECT,
                    payload: {project, projectDrop},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// HIDE OR UNHIDE PROJECT
export const toggleHideProject = (project, showHiddenView) => (dispatch, getState) => {
    console.log("current view shows hidden projects: " + showHiddenView)
    const id = project.project_id;
    const body = project.hidden ? {action: "unhide"} : {action: "hide"};
    axios
        .put(`/v0/api/project/update-project-hide/${id}/`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                if (!showHiddenView) {
                    dispatch({
                        type: SET_PROJ_HIDDEN_HIDE,
                        payload: id,
                    });
                    dispatch(createMessage({ success: `${project.project_name} is now hidden from your projects` }));
                } else {
                    if (project.hidden) {
                        dispatch({
                            type: SET_PROJ_VISIBLE,
                            payload: id,
                        });
                    } else {
                        dispatch({
                            type: SET_PROJ_HIDDEN,
                            payload: id,
                        });
                    }
                } 
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// TOGGLE SHOW / HIDE HIDDEN PROJECTS
export const toggleShowHiddenProjects = () => (dispatch, getState) => {
    dispatch({
        type: TOGGLE_SHOW_HIDDEN_PROJECTS,
        payload: null
    });
};

// CLEAR PROJECT
export const clearProject = () => (dispatch, getState) => {
    dispatch({
        type: CLEAR_PROJECT,
        payload: null
    });
};
// CLEAR PROJECT
export const clearProjects = () => (dispatch, getState) => {
    dispatch({
        type: CLEAR_PROJECTS,
        payload: null
    });
};
// SET PROJECT DROP
export const setProjectDrop = (projectDrop) => (dispatch, getState) => {
    dispatch({
        type: SET_PROJECT_DROP,
        payload: projectDrop
    });
};

// EDIT PROJECT
export const editProject = (id, project) => (dispatch, getState) => {
    axios
        .put(`/v0/api/project/${id}/`, project, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const project = res.data;
                const projectDrop = {project_id: res.data.project_id, project_name: res.data.project_name}
                dispatch({
                    type: EDIT_PROJECT,
                    payload: {project, projectDrop},
                });
                if (project.action === "close") {
                    dispatch(createMessage({ success: "Project successfully closeds." }));
                } else {
                    dispatch(createMessage({ success: "Project successfully updated." }));
                } 
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// DELETE PROJECT
export const deleteProject = (id) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/project/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: DELETE_PROJECT,
                    payload: id,
                });
                dispatch(createMessage({ success: "Project successfully deleted." }));
            } 
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// CREATE PROJECT
export const addProject = (project) => (dispatch, getState) => {
    axios
        .post("/v0/api/project/", project, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const project = res.data;
                const projectDrop = {project_id: res.data.project_id, project_name: res.data.project_name}
                dispatch({
                    type: CREATE_PROJECT,
                    payload: {project, projectDrop},
                });
                dispatch(createMessage({ success: "Project has been successfully created." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// ADD PROJECT FAVORITE
export const addProjectFavorite = (id) => (dispatch, getState) => {
    axios
        .post(`/v0/api/project/update-project-favorite/${id}/`, id, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: ADD_PROJECT_FAVORITE,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// ADD PROJECT VIEWER -- owner-only, grants a same-company colleague full contract visibility
// into this project
export const addProjectViewer = (projectId, email) => (dispatch, getState) => {
    axios
        .post(`/v0/api/project/viewers/${projectId}/`, { email }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: SET_PROJECT_VIEWERS,
                    payload: res.data,
                });
                dispatch(createMessage({ success: "Viewer added" }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// REMOVE PROJECT VIEWER
export const removeProjectViewer = (projectId, userId) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/project/viewers/${projectId}/`, { ...tokenConfig(getState), data: { user_id: userId } })
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: SET_PROJECT_VIEWERS,
                    payload: res.data,
                });
                dispatch(createMessage({ success: "Viewer removed" }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// REMOVE PROJECT FAVORITE
export const removeProjectFavorite = (id) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/project/update-project-favorite/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: REMOVE_PROJECT_FAVORITE,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};